import { IPersonalAccessToken } from '../types/IPersonalAccessToken';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface GetPersonalAccessTokenClientIdsParams {
  userId: string;
}

export interface GetPersonalAccessTokenClientIdsResult  extends IResult {
  tokenInfos: IPersonalAccessToken[];
}

export class GetPersonalAccessTokenClientIdsRequest extends Request<GetPersonalAccessTokenClientIdsParams, GetPersonalAccessTokenClientIdsResult> {
  constructor(params: GetPersonalAccessTokenClientIdsParams) {
    super('getPersonalAccessTokenNames', params);
  }
}
